import {Injectable} from '@angular/core';
import {Face3, Geometry, Mesh, Vector3} from 'three';
import {CalculationDataService} from './calculation-data.service';
import {ContainerService} from '../../Utils/container.service';


@Injectable({
    providedIn: 'root'
})
export class PolySizeService {
    // get
    private _area: number;
    // get and set
    private _faceSet: any;
    private _heightCm: number;

    constructor(private calculationDataService: CalculationDataService,
                private containerService: ContainerService) {
        this._faceSet = new Set();
        this._area = 0;
    }


    get faceSet(): any {
        return this._faceSet;
    }

    set faceSet(value: any) {
        this._faceSet = value;
    }


    get heightCm(): number {
        return this._heightCm;
    }

    set heightCm(value: number) {
        this._heightCm = value;
    }

    get polyArea(): any {
        return this._area;
    }

    /**
     * calculate surface are of complete model
     * @param mesh
     */
    public initPolyArea(mesh: Mesh) {
        this._area = 0;
        const geo = <THREE.Geometry>mesh.geometry;

        for (let i = 0; i < geo.faces.length; i++) {

            const vIdA = geo.faces[i].a;
            const vIdB = geo.faces[i].b;
            const vIdC = geo.faces[i].c;

            const shift = [new Vector3(), new Vector3(), new Vector3()];
            // for (let j = 0; j < this.containerService.targetInfluences.length; ++j) {
            //     const vertices = this.containerService.targets[j].vertices;
            //     const influence = this.containerService.targetInfluences[j];
            //
            //     shift[0].add(vertices[vIdA].clone().multiplyScalar(influence));
            //     shift[1].add(vertices[vIdB].clone().multiplyScalar(influence));
            //     shift[2].add(vertices[vIdC].clone().multiplyScalar(influence));
            // }
            //
            // shift[0].divideScalar(this.containerService.targetInfluences.length);
            // shift[1].divideScalar(this.containerService.targetInfluences.length);
            // shift[2].divideScalar(this.containerService.targetInfluences.length);

            const vA = geo.vertices[vIdA].clone().add(shift[0]);
            const vB = geo.vertices[vIdB].clone().add(shift[1]);
            const vC = geo.vertices[vIdC].clone().add(shift[2]);

            const ab = vB.clone().sub(vA);
            const ac = vC.clone().sub(vA);

            const cross = new Vector3();
            cross.crossVectors(ab, ac);
            this._area += cross.length() / 2;

        }


        // console.log(this._area);
        // heightCm equals modelHeight in makehuman
        console.log(this._area);
        this._heightCm = Math.round(geo.boundingBox.getSize(new Vector3()).y * 1000) / 100;

    }

    /**
     * adds face to face Set
     * @param faceID
     */
    public setMarkedID(faceID: number) {
        this._faceSet.add(faceID);
    }

    /**
     * deletes face from faceSet
     * @param faceID
     */
    public deleteMarkedID(faceID: number) {
        this._faceSet.delete(faceID);
    }

    /**
     * resets all surface areas
     */
    public resetParameters() {
        this.calculationDataService.clear();
    }

    // /**
    //  * calculates surface areas for each burns and store it in calculationDataService
    //  * @param mesh
    //  */
    // public calculateSurface(mesh: Mesh) {
    //     let surfaceTriangle = 0;
    //     let surfaceburn1 = 0;
    //     let surfaceburn2a = 0;
    //     let surfaceburn2b = 0;
    //     let surfaceburn3 = 0;
    //     let surfaceburn4 = 0;
    //
    //     const geo = <THREE.Geometry>mesh.geometry;
    //     // go throw all faces an calculate all surfaces
    //     for (const j of Array.from(this._faceSet)) {
    //         const i = Number(j);
    //         const face = geo.faces[i];
    //
    //         if (face.vertexColors.length > 0) {
    //             const help = this.getFaceSize(face, geo);
    //             surfaceTriangle += help;
    //
    //             if (this.containerService.getCategory(face.vertexColors[0]) === 0) {
    //                 surfaceburn1 += help;
    //             } else if (this.containerService.getCategory(face.vertexColors[0]) === 1) {
    //                 surfaceburn2a += help;
    //             } else if (this.containerService.getCategory(face.vertexColors[0]) === 2) {
    //                 surfaceburn2b += help;
    //             } else if (this.containerService.getCategory(face.vertexColors[0]) === 3) {
    //                 surfaceburn3 += help;
    //             } else if (this.containerService.getCategory(face.vertexColors[0]) === 4) {
    //                 surfaceburn4 += help;
    //             }
    //         }
    //     }
    //     this.calculationDataService.burnarea = (surfaceTriangle * 100) / this._area;
    //     this.calculationDataService.burnarea1 = (surfaceburn1 * 100) / this._area;
    //     this.calculationDataService.burnarea2a = (surfaceburn2a * 100) / this._area;
    //     this.calculationDataService.burnarea2b = (surfaceburn2b * 100) / this._area;
    //     this.calculationDataService.burnarea3 = (surfaceburn3 * 100) / this._area;
    //     this.calculationDataService.burnarea4 = (surfaceburn4 * 100) / this._area;
    //     return this.calculationDataService.burnarea;
    // }

    /**
     * calculate face size
     * @param face
     * @param geometry
     * @return size: number
     */
    public getFaceSize(face: Face3, geometry: Geometry): number {
        const vA = geometry.vertices[face.a];
        const vB = geometry.vertices[face.b];
        const vC = geometry.vertices[face.c];

        const ab = vB.clone().sub(vA);
        const ac = vC.clone().sub(vA);

        const cross = new Vector3();
        cross.crossVectors(ab, ac);
        return cross.length() / 2;
    }
}
